<script setup>
import { computed } from 'vue'
import { Head, Link } from '@inertiajs/vue3'
import { MessageCircle, ChevronRight, Plane } from 'lucide-vue-next'
import AdminLayout from '../../Layout/AdminLayout.vue'

defineOptions({ layout: AdminLayout })

const props = defineProps({
  conversations: { type: Array, required: true },
})

const esperando = computed(() => props.conversations.filter((c) => c.unread > 0).length)
</script>

<template>
  <Head title="Mensagens · Administração" />

  <h1 class="text-xl font-semibold tracking-tight text-up-navy">Mensagens</h1>
  <p class="mt-1 text-sm text-slate-500">
    <template v-if="esperando">
      <strong class="text-up-orange">{{ esperando }}</strong> conversa(s) esperando resposta.
    </template>
    <template v-else>Nenhuma conversa esperando resposta.</template>
    Uma conversa por ordem de serviço.
  </p>

  <p v-if="!props.conversations.length" class="mt-6 rounded-card bg-white p-8 text-center text-sm text-slate-500 shadow-card">
    Nenhuma ordem de serviço nesta unidade ainda.
  </p>

  <ul v-else class="mt-6 space-y-3">
    <li v-for="c in props.conversations" :key="c.id" class="rounded-card bg-white shadow-card">
      <Link
        :href="`/admin/mensagens/${c.id}`"
        class="flex items-start gap-4 px-5 py-4 transition-colors hover:bg-up-bg"
      >
        <span
          class="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-xs font-bold"
          :class="c.unread ? 'bg-up-orange text-white' : 'bg-up-bg text-slate-400'"
          aria-hidden="true"
        >
          <MessageCircle class="h-4 w-4" />
        </span>

        <div class="min-w-0 flex-1">
          <p class="flex flex-wrap items-baseline gap-x-2">
            <span class="font-medium text-up-navy">{{ c.client }}</span>
            <span class="flex items-center gap-1 text-xs text-slate-500">
              <Plane class="h-3.5 w-3.5" aria-hidden="true" />{{ c.aircraft }} · {{ c.serviceOrder }}
            </span>
            <span
              v-if="c.unread"
              class="rounded-full bg-up-orange/10 px-2 py-0.5 text-[11px] font-semibold text-up-orange"
            >{{ c.unread }} não lida(s)</span>
          </p>

          <p v-if="c.lastText" class="mt-1 truncate text-sm text-slate-600">
            <span class="text-slate-400">{{ c.lastFrom === 'team' ? 'Equipe:' : 'Cliente:' }}</span>
            {{ c.lastText }}
          </p>
          <p v-else class="mt-1 text-sm text-slate-400">Nenhuma mensagem ainda.</p>

          <p v-if="c.lastAt" class="mt-0.5 text-xs text-slate-400">
            {{ c.lastAt }}<span v-if="c.lastSubject"> · assunto: {{ c.lastSubject }}</span>
          </p>
        </div>

        <ChevronRight class="mt-1 h-5 w-5 shrink-0 text-slate-300" aria-hidden="true" />
      </Link>
    </li>
  </ul>
</template>
